<template>
    <div class="perfect">
        <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
        >
            <el-form-item label="机构名称" prop="organization">
                <el-input v-model="ruleForm.organization"></el-input>
            </el-form-item>
            <el-form-item label="经办人姓名" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="经办人身份证号" prop="idcard">
                <el-input v-model="ruleForm.idcard"></el-input>
            </el-form-item>
            <el-form-item prop="email" label="邮箱">
                <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
            <!-- <el-form-item prop="zuzhi" label="组织">
        <el-cascader v-model="ruleForm.zuzhi" :options="options" :props="list" :show-all-levels="false" style="float:left;"></el-cascader>
            </el-form-item>-->
            <el-form-item label="身份证正面" style="width:300px;">
                <!-- :auto-upload="false" -->
                <el-upload
                    action
                    list-type="picture-card"
                    :file-list="fileList"
                    :http-request="handleUploadForm"
                    :limit="limitCount"
                    :on-exceed="handleExceed"
                    :before-remove="beforeRemove"
                    :on-remove="handleRemoveFront"
                    accept="image/png, image/jpeg"
                    :class="{hide:hideUpload}"
                    :on-change="changePic"
                >
                    <i slot="default" class="el-icon-plus"></i>
                    <!-- :auto-upload="false" -->
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                    <pic width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
            </el-form-item>
            <el-form-item label="身份证背面" style="width:300px;">
                <el-upload
                    action
                    list-type="picture-card"
                    :file-list="fileList"
                    :http-request="handleUploadForms"
                    :limit="limitCount"
                    :on-exceed="handleExceed"
                    :before-remove="beforeRemove"
                    :on-remove="handleRemoveAfter"
                    accept="image/png, image/jpeg"
                    :class="{hides:hideUploads}"
                    :on-change="changePic"
                >
                    <i slot="default" class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                    <pic width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
            </el-form-item>
            <el-form-item style="margin-top:50px;">
                <el-button type="primary" @click="submitForm()">立即创建</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    name: 'Perfect',
    data() {
        return {
            // 信息提交数据
            ruleForm: {
                organization: '',
                name: '',
                idcard: '',
                email: '',
                delivery: false,
                type: [],
                resource: '',
                desc: '',
                frontPic: '',
                zuzhi: ''
            },
            rules: {
                organization: [
                    {
                        required: true,
                        message: '请填写机构名称',
                        trigger: 'blur'
                    }
                ],
                name: [
                    {
                        required: true,
                        message:
                            '请填写贵公司/团队在职业培训网络大学的业务联系人',
                        trigger: 'blur'
                    },
                    {min:2,message: '请至少输入2位字符',trigger: 'blur'},
                    {max: 20,message: '最多只能输入20位字符',trigger: 'blur'}
                ],
                idcard: [
                    {
                        required: true,
                        message: '仅用于审核身份和实名认证',
                        trigger: 'blur'
                    },
                    {
                        validator: function(rule, value, callback) {
                            var MobileRegex = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/
                            if (!MobileRegex.test(value)) {
                                callback(new Error('身份证号格式不正确！'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                email: [
                    { required: true, message: '仅用于联络', trigger: 'blur' },
                    {
                        type: 'email',
                        message: '请输入正确的邮箱地址',
                        trigger: ['blur', 'change']
                    }
                ],
                zuzhi: [
                    { required: true, message: '请选择', trigger: 'change' }
                ]
            },
            uploadSign: null,
            fileList: [], //文件存储中间量
            dialogVisible: false,
            dialogImageUrl: '', //返回的图片地址
            hideUpload: false, //上传按钮可隐藏
            limitCount: 1,
            disabled: false,
            hideUploads: false
        }
    },
    computed: {},
    created() {},
    methods: {
        submitForm(ruleForm) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    let data = {
                        name: this.ruleForm.organization, //机构名称
                        handleName: this.ruleForm.name, //经办人姓名
                        handlePhone: this.ruleForm.idcard, //经办人身份证号
                        handleEmail: this.ruleForm.email //经办人联系邮箱
                        // platformId:localStorage.getItem('datas')
                    }
                    var qs = require('qs')
                    this.$axios
                        .post(
                            this.$managePath + '/offline/api/org/saveDetails',
                            qs.stringify(data),
                            {
                                headers: {
                                    'Content-Type':
                                        'application/x-www-form-urlencoded'
                                }
                            }
                        )
                        .then(res => {
                            this.$emit('twoactive',2)
                        })
                        .catch(res => {
                            console.log('err')
                        })
                }
            })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
        },
        // 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
        beforeAvatarUpload: function(file) {
            // 判断上传文件类型
            const me = this
            const isJPG = file.type === 'image/jpeg'
            const isPNG = file.type === 'image/png'
            if (!(isJPG || isPNG)) {
                me.$message.error('上传的文件只能是 JPG 或者是 PNG 格式的')
            }
        },
        changePic(file, fileList) {
            // this.hideUpload = fileList.length >= this.limitCount;
        },
        // 文件超出个数限制时的钩子
        handleExceed(file, fileList) {
            const me = this
            me.$message.warning('只能上传一个文件')
        },
        // 上传文件
        handleUploadForm(param) {
            let file = new FormData()
            // if()
            file.append('file', param.file)
            file.append('field', 'handleIdcardUp')
            this.$axios
                .post(this.$managePath + '/offline/api/org/upload', file, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                .then(res => {
                    // if()
                    this.dialogImageUrl = res.data.data
                    this.hideUpload = true
                })
                .catch(res => {
                    console.log('err')
                })
        },
        handleUploadForms(param) {
            let file = new FormData()
            file.append('file', param.file)
            file.append('field', 'handleIdcardDown')
            this.$axios
                .post(this.$managePath + '/offline/api/org/upload', file, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                .then(res => {
                    this.dialogImageUrl = res.data.data
                    this.hideUploads = true
                    if (status === 0) {
                        alert('上传文件失败,请重新上传')
                    }
                })
                .catch(res => {
                    console.log('err')
                })
        },
        // 删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止上传。
        beforeRemove(file, fileList) {
            // 增加一个询问框
            return this.$confirm(`确定移除 ${file.name}？`)
        },
        // 文件列表移除文件时的钩子 因为是三个组件所以便分开写了三个方法，写成一个带参数的试过了不行
        handleRemoveFront(file, fileList) {
            this.hideUpload = fileList.length >= this.limitCount
        },
        handleRemoveAfter(file, fileList) {
            this.hideUploads = fileList.length >= this.limitCount
        }
    }
}
</script>
<style>
</style>
<style>
.perfect {
    width: 40%;
    margin: 50px auto;
}
.el-upload-list el-upload-list--picture {
    margin: 0;
    padding: 0;
    list-style: none;
    width: 400px !important;
    margin-left: 41px;
}
.hide .el-upload--picture-card {
    display: none;
}
.hides .el-upload--picture-card {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/perfect.vue